<template>
  <div class="team-dashboard">
    <!-- Tab Navigation -->
    <div class="dashboard-tabs">
      <button :class="['tab-btn', { active: activeTab === 'posts' }]" @click="activeTab = 'posts'">
        Posts
      </button>
      <button :class="['tab-btn', { active: activeTab === 'chat' }]" @click="activeTab = 'chat'">
        Chat
        <span v-if="totalUnreadCount > 0" class="unread-badge">
          {{ totalUnreadCount > 99 ? '99+' : totalUnreadCount }}
        </span>
      </button>
    </div>

    <!-- Posts Tab Content -->
    <div v-show="activeTab === 'posts'" class="tab-content posts-tab">
      <PostsFeed :team-id="selectedTeam.id" :club-id="userData.clubId" :user-data="userData"
        :team-name="selectedTeam.teamName" :can-create-post="canCreatePost" />
    </div>

    <!-- Chat Tab Content -->
    <div v-show="activeTab === 'chat'" class="tab-content chat-tab">
      <Chats :userData="userData" :selectedTeam="selectedTeam" :currentTeam="currentTeam" />
    </div>
  </div>
</template>

<script>
import PostsFeed from "./PostsFeed/index.vue";
import Chats from "@/components/Chats/index.vue";

export default {
  name: "TeamDashboard",
  components: {
    PostsFeed,
    Chats,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    selectedTeam: {
      type: Object,
      required: true,
    },
    currentTeam: {
      type: Array,
      default: () => [],
    },
    unreadCounts: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeTab: "posts",
    };
  },
  computed: {
    canCreatePost() {
      return (
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach"
      );
    },
    totalUnreadCount() {
      if (!this.unreadCounts) return 0;
      return Object.values(this.unreadCounts).reduce(
        (sum, count) => sum + count,
        0
      );
    },
  },
};
</script>

<style scoped>
.team-dashboard {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f5f7fa;
  max-width: 100%;
  overflow-x: hidden;
}

.dashboard-tabs {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  padding: 0 16px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.tab-btn {
  flex: 1;
  padding: 16px 24px;
  background: none;
  border: none;
  font-size: 15px;
  font-weight: 500;
  color: #65676b;
  cursor: pointer;
  position: relative;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.tab-btn:hover {
  background: #f0f2f5;
}

.tab-btn.active {
  color: #1877f2;
}

.tab-btn.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #1877f2;
  border-radius: 3px 3px 0 0;
}

.unread-badge {
  background: #e41e3f;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
}

.tab-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 100%;
}

.posts-tab {
  padding: 16px;
}

.chat-tab {
  padding: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .dashboard-tabs {
    padding: 0;
  }

  .tab-btn {
    padding: 12px 16px;
    font-size: 14px;
  }

  .posts-tab {
    padding: 8px;
  }
}
</style>
